<app-modal
  modalId="editor-ki-modal"
  (closeModal)="closeModal()"
  style="width: 90%; height: 70%"
>
  <ng-container>
    <h2 class="qundis-page-heading-h2 mb-3">Qundis GPT</h2>
    <div class="editor-modal-grid">
      <div class="editor-col"
           [class.single-column]="!gptResponse()"
           [class.two-columns]="gptResponse()"
      >
        <app-editor
          id="gpt-editor"
          [plugins]="['QundisGPT']"
          [content]="content()"
          [placeholder]="'...'"
          (newEditorEvent)="content.set($event)"
          (gptResponse)="onGptResponse($event)"
        >
        </app-editor>
      </div>
      @if (gptResponse()) {
        <div class="gpt-col">
          <div class="gpt-card">
            <div [innerHTML]="gptResponse()"></div>
            <button type="button" (click)="acceptGptSolution()">Antwort übernehmen</button>
          </div>
        </div>
      }
    </div>
    <app-save-cancel-buttons
      (cancelEvent)="closeModal()"
      class="m-3"
    ></app-save-cancel-buttons>
  </ng-container>
</app-modal>
